import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "guestCart";

const load = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch {
    return [];
  }
};

const save = (items) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
};

const guestCartSlice = createSlice({
  name: "guestCart",
  initialState: { items: load() },
  reducers: {
    addGuestItem(state, { payload }) {
      // payload: { productId (object), quantity, price, color, size, customSize }
      const idx = state.items.findIndex(
        (i) =>
          i.productId._id === payload.productId._id &&
          i.color?._id === payload.color?._id &&
          (i.size?._id ?? null) === (payload.size?._id ?? null) &&
          (i.customSize ?? null) === (payload.customSize ?? null)
      );
      if (idx >= 0) {
        state.items[idx].quantity += payload.quantity;
      } else {
        // Use a stable local id
        state.items.push({ ...payload, _id: `guest_${Date.now()}_${Math.random()}` });
      }
      save(state.items);
    },
    removeGuestItem(state, { payload: id }) {
      state.items = state.items.filter((i) => i._id !== id);
      save(state.items);
    },
    updateGuestItem(state, { payload: { id, quantity } }) {
      const item = state.items.find((i) => i._id === id);
      if (item && quantity >= 1) item.quantity = quantity;
      save(state.items);
    },
    clearGuestCart(state) {
      state.items = [];
      localStorage.removeItem(STORAGE_KEY);
    },
  },
});

export const { addGuestItem, removeGuestItem, updateGuestItem, clearGuestCart } =
  guestCartSlice.actions;

export default guestCartSlice.reducer;
